export interface AttendanceTask {
  payload: any;
  onSuccess: () => void;
  onError: (error: any) => void;
  apiCaller: (data: any, onSuccess: () => void, onError: (err: any) => void) => void;
}

class AttendanceQueueManager {
  private queue: AttendanceTask[] = [];
  private isProcessing = false;
  
  // Local cache to keep track of latest statuses (optimistic updates)
  private userStatusCache: Record<string, "clock-in" | "clock-out"> = {};

  public enqueue(task: AttendanceTask) {
    this.queue.push(task);
    this.processQueue();
  }

  public setOptimisticStatus(userId: string, status: "clock-in" | "clock-out") {
    this.userStatusCache[userId] = status;
  }

  public getOptimisticStatus(userId: string): "clock-in" | "clock-out" | null {
    return this.userStatusCache[userId] || null;
  }

  public clearAllOptimisticStatuses() {
    this.userStatusCache = {};
  }

  private async processQueue() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    while (this.queue.length > 0) {
      const task = this.queue[0]; // peek
      
      try {
        await new Promise<void>((resolve, reject) => {
          task.apiCaller(
            task.payload,
            () => {
              task.onSuccess();
              resolve();
            },
            (error) => {
              task.onError(error);
              resolve(); // Resolve to move to next item. Error is handled by caller.
            }
          );
        });
      } catch (e) {
        console.error("Queue execution error", e);
      }
      
      this.queue.shift(); // remove processed task
    }

    this.isProcessing = false;
  }
}

export const attendanceQueueManager = new AttendanceQueueManager();
